const STORAGE_KEY = process.env.VUE_APP_LOCAL_USER_KEY;

function parseJWT(token) {
    let parts = token.split('.');

    return {
        header: parsePart(parts[0]),
        payload: parsePart(parts[1]),
        sign: parts[2]
    };
}

function parsePart(str) {
    return JSON.parse(atob(str));
}

class TokenService {
    STORAGE_KEY = STORAGE_KEY
    getLocalRefreshToken() {
        return localStorage.getItem(STORAGE_KEY + 'RefreshToken');
    }

    getLocalAccessToken() {
        return localStorage.getItem(STORAGE_KEY + 'AccessToken');
    }

    updateLocalAccessToken(token) {
        localStorage.setItem(STORAGE_KEY + 'AccessToken', token);
    }
    updateLocalRefreshToken(token) {
        localStorage.setItem(STORAGE_KEY + 'RefreshToken', token);
    }

    getUser() {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? null);
    }

    setUser(user) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    }

    removeUser() {
        localStorage.removeItem(STORAGE_KEY);
    }

    clean() {
        this.removeUser()
        localStorage.removeItem(STORAGE_KEY + 'AccessToken');
        localStorage.removeItem(STORAGE_KEY + 'RefreshToken');
    }

    getTokenPayload(token) {
        return parseJWT(token).payload;
    }

    isLogged() {
        return !!this.getLocalAccessToken()
    }
}

export default new TokenService();